/* eslint-disable import/prefer-default-export */

import styled, { css } from 'styled-components'
import { FlexStyleProps } from './types'

export const Wrapper = styled.div<FlexStyleProps>`
  ${({ theme, $direction, $justify, $align, $gap, $wrap, $overflow }) => css`
    display: flex;
    flex-direction: ${$direction};
    justify-content: ${$justify};
    align-items: ${$align};
    gap: ${theme.spacing($gap)};
    flex-wrap: ${$wrap};
    overflow: ${$overflow};
  `}
`

export default {
  Wrapper,
}
